import React from "react"
import styled from "styled-components"
import { BREAKPOINTS } from "../../constants"

const GridGalleryWrapper = styled.div`
  > p {
    display: grid;
    /* max-width: calc(100% - var(--safety-padding) *2);
    width: fit-content !important; */
    margin: 0 !important;
    gap: 1rem;
    justify-items: center;
    grid-template-columns: repeat(
      ${props => Math.floor(Math.sqrt(props.count !== 1 ? props.count + 4 : 1))},
      1fr
    );
    @media (max-width: ${BREAKPOINTS["small-viewport"]}) {
      grid-template-columns: repeat(1, 1fr);
      gap: 0.5rem;
    }
  }
  span {
    padding: 0 !important;
    max-height: 480px;
    /* 
    margin: 0 !important;
    max-width: 100% !important;
    max-height: 40vh !important;
    
    width: fit-content; */
    overflow: hidden;
    border-radius: 1rem;
  }
  img {
    max-height: 480px;
    width: auto !important;
    height: inherit !important;
    position: initial !important;
    margin: 0 !important;
    gap: 1rem;
  }
`
function GridGallery(props) {
  return (
    <GridGalleryWrapper
      count={
        props.children.props.children.filter(
          element => typeof element === "object"
        ).length
      }
    >
      {props.children}
    </GridGalleryWrapper>
  )
}

export default GridGallery
